// The wire codec of the client edge: ocs-proto's CBOR (docs/08 "Frames") over binary
// WebSocket messages. This replaces the interim JSON encoding the terminal bridge used
// before web/packages/ocs-proto was the wasm-pack output.
import type { ClientFrame } from "../proto/frames";
import { FrameDecodeError, type Proto } from "../proto/index";

export interface FrameCodec {
  /** Encode for `WebSocket.send`. */
  encode(frame: ClientFrame): Uint8Array;
  /** Decode a `MessageEvent.data` (binary, with `binaryType = "arraybuffer"`); throws FrameDecodeError. */
  decode(raw: unknown): ClientFrame;
}

export function protoCodec(proto: Proto): FrameCodec {
  return {
    encode: (frame) => proto.encodeFrame(frame),
    decode: (raw) => {
      if (raw instanceof ArrayBuffer) return proto.decodeFrame(new Uint8Array(raw));
      if (raw instanceof Uint8Array) return proto.decodeFrame(raw);
      throw new FrameDecodeError("expected a binary message");
    },
  };
}
